export default __webpack_public_path__ + "static/media/eduYellow.2744e9f2.svg";